module.exports = __webpack_public_path__ + "static/media/aid_2.544fe37c.webp";